// biome-ignore lint/correctness/noUnusedImports: shared renderer also runs in the web tests with classic JSX.
import React from "react";
import type {
  DynamicFurnitureShape as DynamicShape,
  DynamicTableLayout
} from "../../../../types";
import { layoutDynamicTable } from "../../../../utils/dynamicFurniture";

export function DynamicTableSVG({
  layout,
  color = "#E8ECEF"
}: {
  layout: DynamicTableLayout;
  color?: string;
}) {
  const g = layoutDynamicTable(layout);
  return (
    <svg
      viewBox={`0 0 ${g.width} ${g.height}`}
      width="100%"
      height="100%"
      overflow="visible"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {g.parts.map((p) =>
        p.ellipse ? (
          <ellipse
            key={p.key}
            data-part={p.kind}
            cx={p.x + p.width / 2}
            cy={p.y + p.height / 2}
            rx={p.width / 2}
            ry={p.height / 2}
            fill={color}
            stroke="#9CA3AF"
            strokeWidth={1}
          />
        ) : (
          <rect
            key={p.key}
            data-part={p.kind}
            x={p.x}
            y={p.y}
            width={p.width}
            height={p.height}
            rx={p.radius}
            transform={`rotate(${p.rotation} ${p.x} ${p.y})`}
            fill={
              p.kind === "chair-back" || p.kind === "chair-arm"
                ? "#D1D5D9"
                : color
            }
            stroke="#9CA3AF"
            strokeWidth={1}
          />
        )
      )}
    </svg>
  );
}
export function DynamicFurnitureSVG({ shape }: { shape: DynamicShape }) {
  return (
    <g
      data-dynamic-furniture={shape.id}
      transform={`translate(${shape.x} ${shape.y}) rotate(${shape.rotation || 0}) scale(${shape.scaleX ?? 1} ${shape.scaleY ?? 1})`}
    >
      <svg width={shape.width} height={shape.height} overflow="visible">
        <DynamicTableSVG layout={shape.layout} color={shape.color} />
      </svg>
    </g>
  );
}
